import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ImageCropperModule } from 'ngx-image-cropper';
import { FormsModule } from '@angular/forms';
import { SidebarComponent } from './sidebar/sidebar.component';
import { NavbarComponent } from './navbar/navbar.component';
import { FooterComponent } from './footer/footer.component';
import { UploadImageComponent } from './upload-image/upload-image.component';
import { NgxSmartModalModule } from 'ngx-smart-modal';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PipeModule } from '../pipe/pipe.module';
import { QrScanerComponent } from './qr-scaner/qr-scaner.component';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { SearchbarComponent } from './searchbar/searchbar.component';
import { NgxAlertsModule } from '@ngx-plus/ngx-alerts';
import { UploadImageMultipleComponent } from './upload-image-multiple/upload-image-multiple.component';
import { ServiceSearchComponent } from './service-search/service-search.component';
import { RatingStarComponent } from './rating-star/rating-star.component';
import { Navbar2Component } from './navbar2/navbar2.component';
import { MainMenuComponent } from './main-menu/main-menu.component';
import { ModalRewardComponent } from './modal/modal-reward/modal-reward.component';
//import { ModalSuveyComponent } from './modal/modal-survey/modal-survey.component';
import { ModalRedemptionComponent } from './modal/modal-redemption/modal-redemption.component';
import { ModalRedeemedComponent } from './modal/modal-redeemed/modal-redeemed.component';
import { ModalRedemptionStatusComponent } from './modal/modal-redemption-status/modal-redemption-status.component';
import { ModalCancelRedeemComponent } from './modal/modal-cancel-redeem/modal-cancel-redeem.component';
import { AlertComponent } from './alerts/alert/alert.component';
import { ModalMarketInterestedComponent } from './modal/modal-market-interested/modal-market-interested.component';
import { ModalMarketRatingComponent } from './modal/modal-market-rating/modal-market-rating.component';
import { ModalMarketStoreEditComponent } from './modal/modal-market-store-edit/modal-market-store-edit.component';
import { ModalMarketStoreCreateComponent } from './modal/modal-market-store-create/modal-market-store-create.component';
import { ModalMarketProductAddComponent } from './modal/modal-market-product-add/modal-market-product-add.component';
import { ModalMarketCreateStoreSuccessComponent } from './modal/modal-market-create-store-success/modal-market-create-store-success.component';
import { ModalImageCaptureComponent } from './modal/modal-image-capture/modal-image-capture.component';
import { ModalMarketProductEditComponent } from './modal/modal-market-product-edit/modal-market-product-edit.component';
import { ModalImageViewerComponent } from './modal/modal-image-viewer/modal-image-viewer.component';
import { ModalConfirmComponent } from './modal/modal-confirm/modal-confirm.component';
import { ModalInfoComponent } from './modal/modal-info/modal-info.component';
import { ModalMarketTermconditionComponent } from './modal/modal-market-termcondition/modal-market-termcondition.component';
import { ModalMarketInterestInfoComponent } from './modal/modal-market-interest-info/modal-market-interest-info.component';
import { ModalActivityUserRegisterComponent } from './modal/modal-activity-user-register/modal-activity-user-register.component';
import { ModalService } from './modal/modal.service';
import { ModalCompletedComponent } from './modal/modal-completed/modal-completed.component';
import { WaitingPageComponent } from './waiting-page/waiting-page.component';
import { CommentTextareaComponent } from './mention/comment-textarea/comment-textarea.component';
import { MentionModule } from 'angular-mentions';
import { ModalFriendComponent } from './modal/modal-friend/modal-friend.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { CustomTranslateLoader } from '../translate.config';
import { HttpClient } from '@angular/common/http';
import { ModalPointTransferComponent } from './modal/modal-point-transfer/modal-point-transfer.component';
import { ModalPointTransferredComponent } from './modal/modal-point-transferred/modal-point-transferred.component';
import { ModalRedeemInformationComponent } from './modal/modal-redeem-information/modal-redeem-information.component';
import { ServeySubmitConfirmComponent } from './modal/servey-submit-confirm/servey-submit-confirm.component';
import { SwitchAccountModalComponent } from './modal/switch-account-modal/switch-account-modal.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    NgbModule,
    ImageCropperModule,
    NgxSmartModalModule.forRoot(),
    ModalModule.forRoot(),
    PipeModule,
    MentionModule,
    ZXingScannerModule,
    FormsModule,
    NgxAlertsModule.forRoot(),
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useClass: CustomTranslateLoader,
        deps: [HttpClient]
      }
    }),
  ],
  declarations: [
    FooterComponent,
    NavbarComponent,
    SidebarComponent,
    UploadImageComponent,
    QrScanerComponent,
    SearchbarComponent,
    UploadImageMultipleComponent,
    ServiceSearchComponent,
    RatingStarComponent,
    Navbar2Component,
    MainMenuComponent,
    ModalRewardComponent,
    ModalRedemptionComponent,
    ModalRedeemedComponent,
    ModalRedemptionStatusComponent,
    ModalCancelRedeemComponent,
    AlertComponent,
    ModalMarketInterestedComponent,
    ModalMarketRatingComponent,
    ModalMarketStoreEditComponent,
    ModalMarketStoreCreateComponent,
    ModalMarketProductAddComponent,
    ModalMarketCreateStoreSuccessComponent,
    ModalImageCaptureComponent,
    ModalMarketProductEditComponent,
    ModalImageViewerComponent,
    ModalConfirmComponent,
    ModalInfoComponent,
    ModalMarketTermconditionComponent,
    ModalMarketInterestInfoComponent,
    ModalActivityUserRegisterComponent,
    ModalCompletedComponent,
    WaitingPageComponent,
    CommentTextareaComponent,
    ModalFriendComponent,
    ModalPointTransferComponent,
    ModalPointTransferredComponent,
    ModalRedeemInformationComponent,
    ServeySubmitConfirmComponent,
    SwitchAccountModalComponent,
  ],
  exports: [
    FooterComponent,
    NavbarComponent,
    SidebarComponent,
    UploadImageComponent,
    QrScanerComponent,
    SearchbarComponent,
    UploadImageMultipleComponent,
    ServiceSearchComponent,
    RatingStarComponent,
    Navbar2Component,
    MainMenuComponent,
    ModalRewardComponent,
    ModalRedemptionComponent,
    ModalRedeemedComponent,
    ModalRedemptionStatusComponent,
    ModalCancelRedeemComponent,
    AlertComponent,
    ModalMarketInterestedComponent,
    ModalMarketRatingComponent,
    ModalMarketStoreEditComponent,
    ModalMarketStoreCreateComponent,
    ModalMarketProductAddComponent,
    ModalMarketCreateStoreSuccessComponent,
    ModalImageCaptureComponent,
    ModalMarketProductEditComponent,
    ModalImageViewerComponent,
    ModalConfirmComponent,
    ModalInfoComponent,
    ModalMarketTermconditionComponent,
    ModalMarketInterestInfoComponent,
    ModalActivityUserRegisterComponent,
    ModalCompletedComponent,
    WaitingPageComponent,
    CommentTextareaComponent,
    ModalFriendComponent,
    ModalPointTransferComponent,
    ModalPointTransferredComponent,
    ModalRedeemInformationComponent,
    ServeySubmitConfirmComponent,
    SwitchAccountModalComponent
  ],
  // providers: [
  //   ModalService
  // ]
})
export class ComponentsModule {}
